// test395
(395 && 0);
